const ACCESS_TOKEN_STORAGE_KEY = 'galaxy_access_token';
const PERSIST_ROOT_KEY = 'persist:root';

class AccessTokenManager {
  constructor() {
    try {
      if (localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY)) return;

      const persistedRoot = localStorage.getItem(PERSIST_ROOT_KEY);
      if (!persistedRoot) return;

      const parsed = JSON.parse(persistedRoot);
      const authReducerStr = parsed.authReducer;
      if (!authReducerStr) return;

      const authState = JSON.parse(authReducerStr);
      const token = authState?.user?.auth_token;
      if (typeof token === 'string' && token.length > 0) {
        localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
      }
    } catch {
      // malformed JSON or localStorage unavailable — skip migration
    }
  }

  getAccessToken(): string | null {
    try {
      return localStorage.getItem(ACCESS_TOKEN_STORAGE_KEY);
    } catch {
      return null;
    }
  }

  setAccessToken(token: string): void {
    try {
      localStorage.setItem(ACCESS_TOKEN_STORAGE_KEY, token);
    } catch {
      // localStorage unavailable
    }
  }

  clearAccessToken(): void {
    try {
      localStorage.removeItem(ACCESS_TOKEN_STORAGE_KEY);
    } catch {
      // localStorage unavailable
    }
  }
}

export const accessTokenManager = new AccessTokenManager();
